<template>
  <v-autocomplete
    ref="provinceRef"
    :items="provinces"
    :value="value"
    @input="input"
    dense
    outlined
    placeholder="Start typing to search provinces"
    label="Province"
    autocomplete="off"
    v-on="listeners"
    v-bind="attrs"
  >
    <template v-slot:label>
      {{attrs.label || 'Province'}}
      <span v-if="required" class="red--text">*</span>
    </template>
  </v-autocomplete>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ProvincePicker',

  props: {
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  
  watch: {
    provinces: {
      immediate: true,
      handler(provs) {
        if (!Array.isArray(provs) || provs.length === 0) return;

        const selectedValue = this.value || '';
        if (selectedValue && !provs.includes(selectedValue.trim())) {
          this.$emit('input', '');
        }
      }
    }
  },

  computed: {
    ...mapGetters('coreModule', ['provinces']),

    listeners() {
      const { ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { ...attrs } = this.$attrs;
      return attrs;
    }
  },

  methods: {
    input(value) {
      this.$emit('input', value);
    }
  }
};
</script>



